import { defineRouting } from "next-intl/routing"
import { env } from "@/lib/env"

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "es", "pt"],
  localeDetection: false,
  // Used when no locale matches
  defaultLocale: env.NEXT_PUBLIC_DEFAULT_LOCALE as "en" | "es" | "pt",
})
